import React from 'react';
import { CheckIcon, FlaskConicalIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-primary/30 bg-surface py-16 sm:py-20" aria-labelledby="final-title" data-id="element-60" data-mp="15dltgwe5qss3">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-61" data-mp="1jclhq2xrd5nq">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-foreground sm:text-4xl" data-id="element-62" data-mp="1jb21udg0kwmh">
          <span className="inline-flex items-center gap-2" data-id="element-63" data-mp="1t3g6pf2e2jcv">
            <FlaskConicalIcon className="h-8 w-8 shrink-0 text-accent" aria-hidden="true" data-id="element-64" data-mp="1t510v3ksk0a7" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-accent sm:text-2xl" data-id="element-65" data-mp="223mimwifvb9x">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-muted" data-id="element-66" data-mp="1x6cr9bbhopjg">
          Created by industrial chemistry and process engineering technical specialists, for professionals worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-67" data-mp="s6ikb8lan6l0">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-68" data-mp="1246h042gmo5t">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-69" data-mp="1b3jr8yyergrl">
              <CheckIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-70" data-mp="1b1grhn7ge99o" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}